const ENVIRONMENTS = {
  development: {
    BASE_URL:
      "https://odger0qa21.execute-api.ap-south-1.amazonaws.com/dev",
  },
};
export const ENV_CONFIG = ENVIRONMENTS["development"];
